// @flow
import * as React from 'react';

type RequiredProps = {| version: string |};

const documentTitles = {
  SHOP: 'Shop',
  EDIT: 'Edit',
  ADDONS: 'Add-Ons',
};

function withDocumentTitle<OwnProps>(
  WrappedComponent: React.AbstractComponent<OwnProps>
): React.AbstractComponent<{| ...OwnProps, ...RequiredProps |}> {
  return class WithDocumentTitle extends React.Component<{|
    ...OwnProps,
    ...RequiredProps,
  |}> {
    componentDidMount() {
      this.setDocumentTitle();
    }

    componentDidUpdate = (prevProps) => {
      if (prevProps.version !== this.props.version) this.setDocumentTitle();
    };

    setDocumentTitle = () => {
      const { version } = this.props;
      switch (version) {
        case 'shop': {
          document.title = `${documentTitles.SHOP} - FabFitFun`;
          break;
        }
        case 'edit': {
          document.title = `${documentTitles.EDIT} - FabFitFun`;
          break;
        }
        case 'add-ons': {
          document.title = `${documentTitles.ADDONS} - FabFitFun`;
          break;
        }
        default: {
          document.title = 'FabFitFun';
        }
      }
    };

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
}

export default withDocumentTitle;
